import { useEffect } from "react";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks/useTypedQuery";
import { CommunicationSettingsQueryKeys } from "modules/CommunicationSettings/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCommunicationSettingsQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const { data, isLoading, refetch } = useTypedQuery({
    queryKey: CommunicationSettingsQueryKeys.settings,
    queryFn: async ({ endpoint, baseUrl }) => {
      if (!selectedLocation?.id) throw new Error("invalid location");
      return (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation.id }, baseUrl)).data.settings;
    },
    enabled: Boolean(selectedLocation?.id)
  });

  useEffect(() => {
    if (selectedLocation?.id) refetch();
  }, [selectedLocation?.id]);

  return { data, isLoading };
};
